<template>
  <div>
    <mdb-row>
      <mdb-col>
        <mdb-btn @click="addNewUserPromoCodeBanner" color="primary" size="sm">{{ $t("add_new_userpromocodebanner") }}</mdb-btn>
      </mdb-col>
    </mdb-row>
    <DataTableAG :columns="columns" :getcontentpath="getuserpromocodebannerspath" :rowHeight="120" :key="componentKey"
      jsonobject="userpromocodebanners" :buttonList="['Muokkaa', 'Aktivoi/Deaktivoi', 'Arkistoi']"
      v-on:pressed-button1="editUserPromocodeBanner" v-on:pressed-button2="updateUserPromocodeBannerActiveStatus"
      v-on:pressed-button3="archiveUserPromocodeBanner" width="1200px" height="750px" />
  </div>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbRow, mdbCol, mdbBtn } from "mdbvue";
export default {
  name: "UserPromoCodeBanners",
  components: {
    DataTableAG,
    mdbRow,
    mdbCol,
    mdbBtn,
  },
  methods: {
    addNewUserPromoCodeBanner() {
      this.$router.push("/adduserpromocodebanner");
    },
    editUserPromocodeBanner(rowData) {
      this.$router.push("/adduserpromocodebanner/" + rowData.id);
    },
    updateUserPromocodeBannerActiveStatus(rowData) {
      // Implement the logic to update the active status of the user promo code banner
      // You can make an API call to update the status in the backend
      // Example:
      const newStatus = rowData.active ? 0 : 1; // Toggle the active status
      // Make an API call to update the status
      this.$http.put(this.activestatususerpromocodebannerpath, JSON.stringify({
        id: rowData.id,
        active: newStatus,
      })).then(() => {
        // Handle successful response, e.g., refresh the data table
        this.componentKey += 1; // Increment the key to force re-render
      }).catch((error) => {
        // Handle error, e.g., show an error message
        console.error("Error updating user promo code banner status:", error);
      });
    },
    archiveUserPromocodeBanner(rowData) {
      // Implement the logic to archive the user promo code banner
      // You can make an API call to archive the banner in the backend
      // Example:
      this.$http.delete(this.archiveuserpromocodebannerpath + rowData.id).then(() => {
        // Handle successful response, e.g., refresh the data table
        this.componentKey += 1; // Increment the key to force re-render
      }).catch((error) => {
        // Handle error, e.g., show an error message
        console.error("Error archiving user promo code banner:", error);
      });
    },
  },
  data: () => ({
    getuserpromocodebannerspath: "/1.0/front/userpromocodebanners",
    archiveuserpromocodebannerpath: "/1.0/front/userpromocodebanner/",
    activestatususerpromocodebannerpath: "/1.0/front/userpromocodebanner/activestatus",
    componentKey: 0,
    columns: [
      {
        field: "unionmemberid",
        headerName: "Jäsenliitto",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "image",
        headerName: "Kuva",
        width: 250,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleImageComponent",
      },
      {
        field: "url",
        headerName: "Tyyppi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "validfrom",
        headerName: "Alkaen",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "validto",
        headerName: "Päättyen",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "active",
        headerName: "Aktiivinen",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() { },
};
</script>
